import { ReactNode, CSSProperties } from "react"

export const Label = (props: { style?: CSSProperties, children: React.ReactNode | React.ReactNode[] }) => {
    return <div  {...props} style={{ padding: '0 4px 4px 0', ...props.style }}>{props.children}</div>
}

export const Container = ({ children, style }: {
    children: ReactNode | ReactNode[], style?: CSSProperties
}) => {
    return <div style={{
        borderRadius: 4,
        padding: 8,
        background: 'rgb(248 250 252)',
        marginBottom: 10,
        marginRight: 10,
        ...style
    }}>
        {children}
    </div>
}

export const SubContainer = ({ children, style }: {
    children: ReactNode | ReactNode[], style?: CSSProperties
}) => {
    return <div style={{
        borderRadius: 4,
        padding: 8,
        background: 'rgb(239 246 255)',
        marginBottom: 10,
        marginRight: 10,
        ...style
    }}>
        {children}
    </div>
}

export const KeyVal = ({
    name, value, style, hideSplitor = false
}: { name: any, value: any, style?: CSSProperties, hideSplitor?: boolean }) => {
    return <div style={{ marginBottom: 10, ...style }}>
        <span style={{ marginRight: 10, }}>{name}{hideSplitor ? '' : ''}</span>
        <span>{value}</span>
    </div>
}

export const SectionTitle = (props: { children?: React.ReactNode | React.ReactNode[] }) => {
    return <div style={{ borderLeft: '2px solid blue', padding: 4, lineHeight: 1 }} {...props}>{props.children}</div>
}